import { useState } from 'react';
import { apiJson } from '../api/client.js';

export function TwoFactorUserControls({ userId, enabled = false, enforced = false, onChanged }) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  const run = async (action) => {
    const requireIt = action === 'require';
    const confirmed = window.confirm(
      requireIt
        ? 'Require an authenticator app for this user? They will set it up the next time they sign in.'
        : 'Turn off two-factor authentication for this user? They will sign in with a password only.',
    );
    if (!confirmed) {
      return;
    }
    setBusy(true);
    setError('');
    try {
      await apiJson(`/api/admin/users/${userId}/two-factor/${requireIt ? 'require' : 'disable'}`, {
        method: 'POST',
      });
      await onChanged?.();
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  };

  const label = enabled ? (enforced ? '2FA on, required' : '2FA on') : enforced ? '2FA required' : '2FA off';

  return (
    <span className="two-factor-admin">
      <span className="muted small">{label}</span>
      {!enforced ? (
        <button type="button" className="btn btn-outline-secondary btn-sm" disabled={busy} onClick={() => void run('require')}>
          Require 2FA
        </button>
      ) : null}
      {enabled || enforced ? (
        <button type="button" className="btn btn-outline-secondary btn-sm" disabled={busy} onClick={() => void run('disable')}>
          Disable 2FA
        </button>
      ) : null}
      {error ? <span className="err small">{error}</span> : null}
    </span>
  );
}
